/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import { i18n } from 'element-react';
import locale from 'element-react/src/locale/lang/ko';

i18n.use(locale);

import 'styles/main.scss';
import 'element-theme-default';
import 'lib/localCart';
import storage, { keys } from 'lib/storage';
import * as gtmTracker from 'lib/tracking/gtmTracker';

// import registerServiceWorker from './registerServiceWorker';

const render = window.__REDUX_STATE__ ? ReactDOM.hydrate : ReactDOM.render;
const isDev = process.env.NODE_ENV === 'development' || process.env.MODE_ENV === 'staging';

if (typeof window !== 'undefined') {
  render(<Root />, document.getElementById('root'));
}
// registerServiceWorker();

if (!isDev) {
  // GA4 user_id/속성을 GTM 설정 태그가 발동하는 gtm.js 이벤트보다 "먼저" dataLayer에 넣는다.
  // 기본 태그는 gtm.js 시점(dataLayer index 0)에 발동하므로, user_id가 그 앞 index에 있어야
  // 초기 session_start/page_view에 담긴다. dataLayer를 먼저 생성해 push하고, 아래 GTM
  // 스니펫은 같은 배열(w[l] = w[l] || [])을 재사용한다. (로그인 유저는 localStorage에서 동기 접근)
  window.dataLayer = window.dataLayer || [];
  try {
    const storedUser = storage.get(keys.user);
    if (storedUser && storedUser.id) {
      gtmTracker.setUser(storedUser);
    }
  } catch (e) {
    // ignore
  }

  // GTM Load
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KJXF37L');

  // Clarity Load
  (function(c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'su1br4d3ti');
}



// WEBPACK FOOTER //
// ./src/index.js